<script>
  import Vue from 'vue';
  import VueChartJs from 'vue-chartjs';
  export default {
    name: 'bar-chart',
    extends: VueChartJs.Bar,
    mixins: [VueChartJs.mixins.reactiveProp],
    props: ['options'],
    mounted () {
      this.fillData()
    },
    methods: {
      fillData () {
        this.renderChart(this.chartData, this.options)
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/BarChart.vue